<template>
  <div>
    <Hero />
    <Features />
    <Perks />
    <section class="py-4">
      <v-container>
        <v-row align="center">
          <v-col cols="12">
            <div class="text-lg-center">
              <h3 class="text-h4 font-weight-light">
                <!-- Bestselling Prints -->
                Highest Rated
              </h3>
            </div>
            <div v-if="loading" class="text-center mt-6">
              <v-icon large>fal fa-spinner fa-spin</v-icon>
            </div>
          </v-col>
          <v-col v-for="(photo, index) in bestSellingList" :key="index" md="4">
            <Print-card :photo="photo" />
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="py-4">
      <v-container>
        <v-row align="center">
          <v-col cols="12">
            <div class="text-lg-center">
              <h3 class="text-h4 font-weight-light">
                Be the First to Buy
              </h3>
            </div>
            <div v-if="loading" class="text-center mt-6">
              <v-icon large>fal fa-spinner fa-spin</v-icon>
            </div>
          </v-col>
          <v-col v-for="(photo, index) in firstToBuyList" :key="index" md="4">
            <Print-card :photo="photo" />
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="py-4">
      <v-container>
        <v-row align="center">
          <v-col cols="12">
            <div class="text-lg-center">
              <h3 class="text-h4 font-weight-light">
                Top Categories
              </h3>
            </div>
            <div v-if="loading" class="text-center mt-6">
              <v-icon large>fal fa-spinner fa-spin</v-icon>
            </div>
          </v-col>
          <v-col
            v-for="(photo, index) in topCategoriesList"
            :key="index"
            md="4"
          >
            <Print-card :photo="photo" :is-category="true" />
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Hero from '@/components/shop/Hero.vue'
import Features from '@/components/shop/Features.vue'
import Perks from '@/components/shop/Perks.vue'
import PrintCard from '@/components/shop/PrintCard.vue'

export default {
  components: {
    Hero,
    Features,
    Perks,
    PrintCard
  },
  data() {
    return {
      loading: false
    }
  },
  head({ $seo }) {
    return $seo({
      title: 'Photo Selling Shop',
      description: 'Discover our beautiful collection. Outstanding images. Limited editions. Best photo selling website.'
    })
  },
  computed: {
    ...mapState({
      bestSellingList: state => state.prints.bestSellingList,
      firstToBuyList: state => state.prints.firstToBuyList,
      topCategoriesList: state => state.prints.topCategoriesList
    })
  },
  async mounted() {
    if (this.firstToBuyList.length === 0) {
      try {
        this.loading = true
        await this.$store.dispatch('prints/getShopPhotos')
      } catch (error) {
        this.$asa.appInsights('Pages: shop/index.vue - method: mounted', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.bg-light-blue {
  background-color: #e1f5fe;
}
.bg-light-grey {
  background-color: #eee;
}
.h-400 {
  height: 400px;
}
.hero-image {
  background-image: url('https://100asastorageaccount.blob.core.windows.net/photos/122/4201fcc3-81f8-4c6a-9176-7194b4586647-DSC07566-Bearbeitet-2-th.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  position: relative;
  text-decoration: none;
  width: 100%;
  height: 400px;
}
.home-photo-caption {
  color: white;
  position: absolute;
  bottom: 0;
  right: 25px;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.7);
}
</style>
